import { List } from 'antd';
import type { CSSProperties, ReactNode } from 'react';
import React, { forwardRef } from 'react';

import './SListItem.scss';

export const SListItem = forwardRef<HTMLElement, Props>(
  (
    { title, description, avatar, actions, onClick, className = '', style },
    ref
  ) => (
    <List.Item
      ref={ref}
      className={`slist-item ${className}`}
      actions={actions}
      onClick={onClick}
      style={style}
    >
      <List.Item.Meta avatar={avatar} title={title} description={description} />
    </List.Item>
  )
);

SListItem.displayName = 'SListItem';

type Props = {
  title: string | ReactNode;
  description?: string | ReactNode;
  avatar?: ReactNode;
  actions?: ReactNode[];
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
};
